import { csv as downloadCsvFile } from "./formats/csv";
import { json as downloadJsonFile } from "./formats/json";
import { plain as downloadPlainTextFile } from "./formats/plain";
import { xlsx as downloadXlsxFile } from "./formats/xlsx";

export { downloadCsvFile, downloadJsonFile, downloadPlainTextFile, downloadXlsxFile };
